import lang from '../../lib/language';
import { CommissionStatusEnum, ReferralStatusEnum } from '../../lib/models/crm/types';

import { PayoutModalIconEnum, PayoutRequestStateEnum } from '../../containers/Referrals/Referrals.types';

import { StatusBadgeVariantEnum } from './ReferralStatusBadge/ReferralStatusBadge.types';

type BadgeDescriptor = {
  label: string;
  variant: StatusBadgeVariantEnum;
};

type PayoutModalContent = {
  description: string;
  icon: PayoutModalIconEnum;
  /** The confirm step is the only one that acts on its primary button and offers a way out. */
  isConfirmStep: boolean;
  primaryLabel: string;
  title: string;
};

export const getReferralStatusBadge = (status: ReferralStatusEnum): BadgeDescriptor => (
  status === ReferralStatusEnum.purchased
    ? { label: lang.referralsStatusPurchased(), variant: StatusBadgeVariantEnum.success }
    : { label: lang.referralsStatusNotPurchased(), variant: StatusBadgeVariantEnum.neutral }
);

export const getCommissionStatusBadge = (status: CommissionStatusEnum): BadgeDescriptor => {
  switch (status) {
    case CommissionStatusEnum.paid:
      return { label: lang.referralsStatusPaid(), variant: StatusBadgeVariantEnum.success };
    case CommissionStatusEnum.requested:
      return { label: lang.referralsStatusRequested(), variant: StatusBadgeVariantEnum.warning };
    case CommissionStatusEnum.rejected:
      return { label: lang.referralsStatusRejected(), variant: StatusBadgeVariantEnum.danger };
    default:
      return { label: lang.referralsStatusAvailable(), variant: StatusBadgeVariantEnum.neutral };
  }
};

export const getPayoutModalContent = (
  state: PayoutRequestStateEnum,
  amountLabel: string,
): PayoutModalContent => {
  switch (state) {
    case PayoutRequestStateEnum.submitted:
      return {
        description: lang.referralsPayoutSubmittedDescription(amountLabel),
        icon: PayoutModalIconEnum.success,
        isConfirmStep: false,
        primaryLabel: lang.referralsPayoutDone(),
        title: lang.referralsPayoutSubmittedTitle(),
      };
    case PayoutRequestStateEnum.failed:
      return {
        description: lang.referralsPayoutFailedDescription(amountLabel),
        icon: PayoutModalIconEnum.error,
        isConfirmStep: false,
        primaryLabel: lang.commonOkay(),
        title: lang.referralsPayoutFailedTitle(),
      };
    default:
      return {
        description: lang.referralsPayoutConfirmDescription(amountLabel),
        icon: PayoutModalIconEnum.wallet,
        isConfirmStep: true,
        primaryLabel: lang.referralsPayoutConfirm(),
        title: lang.referralsPayoutConfirmTitle(),
      };
  }
};
